if($('.client-center-box').length){
    $('.client-center-box li.logout').after('<li><a href="/moje-garaz/">Moje garáž</a></li>');
}

if($('.top-navigation-tools a.top-nav-button-account.secondary').length){
    if($('.id-21871').length){
        if(sessionStorage.clientCenter) {
                $('#content-wrapper .content-wrapper-in').prepend(sessionStorage.clientCenter);
                $('.client-center-box li.logout').after('<li><a href="/moje-garaz/">Moje garáž</a></li>');
        } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/klient/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("aside").html();
                    null !== t && ($('.content-wrapper-in').prepend('<aside class="sidebar sidebar-left" data-editorid="sidebar">'+t+'</aside>'))
                    $('.client-center-box li.logout').after('<li><a href="/moje-garaz/">Moje garáž</a></li>');
                    sessionStorage.clientCenter = '<aside class="sidebar sidebar-left" data-editorid="sidebar">'+t+'</aside>';
                    }
                });
        }


        $.ajax({
            url: 'https://tools.shopcode.cz/mojeRC/api/garage_list.php',
            method: 'GET',
            data: {
              email: getShoptetDataLayer('customer').email
            }
          })
          .done(function(response) {
            if (response.success) {
                if(response.products.length > 0){
                    $('article div[itemprop="about"]').append('<div id="myGarageContainer"><div class="garageProduct"></div><div id="mySparePartsContainer"></div></div>')
                    $.each(response.products, function(index, item) {
                        var garageProduct = '<div class="garagItem" data-code="'+item.productCode+'">';
                        garageProduct += '<div class="p">'
                        garageProduct += '<a href="' + item.orig_url+ '"><img src="' + item.image.replace('/orig/', '/detail/') + '" alt="' + item.name + '"></a>';
                        garageProduct += '<div class="name"><a href="' + item.orig_url+ '">' + item.name + '</a></div>';
                        garageProduct += '<div class="DisplaySpareParts"><span data-code="'+item.productCode+'">Ukaž náhradní díly</span></div>';
                        garageProduct += '</div>';
                        garageProduct += '</div>';
                        $('#myGarageContainer .garageProduct').append(garageProduct);
                    });
                    garageSlider();
                }
                else{
                    $('article div[itemprop="about"]').text('Zatím nemáte žádné zaparkované produkty. Zaparkujte si je a získejte přehled náhradních dílů.')
                }

            } else {
              console.error('Nepodařilo se načíst kódy:', response.message);
            }
          })
          .fail(function(jqXHR, textStatus, errorThrown) {
            console.error('Chyba při komunikaci:', textStatus, errorThrown);
        }); 
        
        $(document).on('click', '.DisplaySpareParts span', function() {
          var dataUrl = $(this).data('code'); 
          $.ajax({
            url: 'https://tools.shopcode.cz/mojeRC/api/spareParts.php',
            method: 'GET',
            data: {
              code: dataUrl
            }
          })
          .done(function(response) {
            if (response.success) {
              console.log('Nalezené produkty:', response.products);
              $('#mySparePartsContainer').empty();
              $('#mySparePartsContainer').prepend('<h3>Náhradní díly pro produkt</h3>')
              var groupedByPartType = {};
              $.each(response.products, function(idx, product) {
                var partType = product.partType || "Ostatní";
                if (!groupedByPartType[partType]) {
                  groupedByPartType[partType] = [];
                }
                groupedByPartType[partType].push(product);
              });
              $.each(groupedByPartType, function(partType, products) {
                var $partTypeBlock = $('<div class="partTypeBlok"></div>');
                $partTypeBlock.append('<h4>' + partType + '</h4>');
                $.each(products, function(idx, product) {
                  var itemHtml = '<div class="partItem">' +
                    '<div class="p">'+
                    '<div class="left"><img src="' + product.img + '" alt="Obrázek"></div>'+
                    '<div class="right">'+
                    '<div class="name"><a href="' + product.url + '">' + product.name + '</a></div>' +
                    '<div class="link"><a href="' + product.url + '">Detail</a></div>' +
                    '</div>'+
                    '</div>'+
                  '</div>';
                  $partTypeBlock.append(itemHtml);
                });
                $('#mySparePartsContainer').append($partTypeBlock);
              });
        
            } else {
              console.error('Nepodařilo se načíst ND:', response.message);
            }
          })
          .fail(function(jqXHR, textStatus, errorThrown) {
            console.error('Chyba při volání spareParts.php:', errorThrown);
          });
        });
              
    }
}

function garageSlider(){
  $('.garageProduct').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: false,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
         slidesToShow: 3,
         slidesToScroll: 1,
         
       }
       
      },
      {
        breakpoint: 768,
        settings: {
         slidesToShow: 3,
         slidesToScroll: 3,
       }
       
      },
      {
        breakpoint: 480,
        settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
         
       }
       
      }
    ]
   });
}